import { useState } from 'react'
import { Box, Typography, IconButton, Collapse } from '@mui/material'
import {
  ChevronRight20Regular,
  ChevronDown20Regular,
  Copy20Regular,
  Checkmark20Regular,
} from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { copyIcon14Sx, copyIcon16Sx } from '../shared/copyIconSx.js'
import {
  jsonBlockBodySx,
  jsonBlockCopyButtonSx,
  jsonBlockHeaderLeadingSx,
  jsonBlockHeaderSx,
  jsonBlockPreSx,
  jsonBlockRootSx,
  jsonBlockTitleSx,
} from './jsonBlockViewSx.js'

export default function JSONBlock({ data, title = 'JSON Data' }) {
  const [expanded, setExpanded] = useState(false)
  const [copied, setCopied] = useState(false)

  return (
    <Box sx={jsonBlockRootSx}>
      <Box onClick={() => setExpanded((open) => !open)} sx={jsonBlockHeaderSx}>
        <Box sx={jsonBlockHeaderLeadingSx}>
          {expanded ? (
            <Box component="span" sx={copyIcon16Sx} aria-hidden>
              <ChevronDown20Regular />
            </Box>
          ) : (
            <Box component="span" sx={copyIcon16Sx} aria-hidden>
              <ChevronRight20Regular />
            </Box>
          )}
          <Typography variant="body2" sx={jsonBlockTitleSx}>
            {title}
          </Typography>
        </Box>
        <Tooltip text={copied ? 'Copied!' : 'Copy JSON'} placement="top">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              navigator.clipboard.writeText(JSON.stringify(data, null, 2))
              setCopied(true)
              setTimeout(() => setCopied(false), 2000)
            }}
            sx={jsonBlockCopyButtonSx}
          >
            {copied ? (
              <Box component="span" sx={copyIcon14Sx} aria-hidden>
                <Checkmark20Regular />
              </Box>
            ) : (
              <Box component="span" sx={copyIcon14Sx} aria-hidden>
                <Copy20Regular />
              </Box>
            )}
          </IconButton>
        </Tooltip>
      </Box>
      <Collapse in={expanded}>
        <Box sx={jsonBlockBodySx}>
          <Typography component="pre" variant="body2" sx={jsonBlockPreSx}>
            {JSON.stringify(data, null, 2)}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  )
}
